import styled from 'styled-components'
import { Modal, Button as Btn } from 'react-bootstrap'
import { Button } from 'components'

export const CloseButton = styled(Button)`
  margin: 0;
`;

export const Body = styled(Modal.Body)`
  padding: 0;
`

export const ModalFooter = styled(Modal.Footer)`
  border: 0;
  justify-content: center;

  > button:last-child {
    color: gray;
  }
`

export const Header = styled(Modal.Header)`
  border: 0;
  font-size: 1.3rem;
  font-weight: 600;

  > .close {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }

  a {
    color: ${({ theme }) => theme.palette.primary[2]};
  }
`

export const ModalContainer = styled(Modal)`
  font-size: ${({ theme }) => theme.sizes.normal};
  color: ${({ theme }) => theme.palette.grayscale[1]};

  .modal-content {
    border-radius: 0.8rem;
    padding: 1rem 2rem;
    border: 0;
  }

  > div {
    max-width: 600px;
  }

  .container {
    overflow-y: auto;
    overflow-x: hidden;
    max-width: 100%;

    > div {
      width: 100%;
      > div {
        width: 100%;
      }
    }
  }
`

export const SnoozeContainer = styled.div`
  margin: 0 auto;
`

export const Description = styled.div`
  border: 2px solid ${({ theme }) => theme.palette.primary[3]};
  background-color: ${({ theme }) => theme.palette.primary[4]};
  padding: 1rem;
`
